(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["index"] = factory();
	else
		root["___Lottery___"] = root["___Lottery___"] || {}, root["___Lottery___"]["index"] = factory();
})(window, function() {
return 